import React from 'react';
import { Link } from 'react-router-dom';
import { Music, Instagram, Twitter, Facebook, Youtube } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 pt-12 pb-6 hidden md:block">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and About */}
          <div className="col-span-1">
            <div className="flex items-center mb-4">
              <Music className="w-8 h-8 text-purple-500" />
              <span className="ml-2 text-xl font-bold text-white">JustJam</span>
            </div>
            <p className="text-sm mb-4">
              Connect with local musicians, discover new talent, and never miss a jam session.
            </p>
            {/* <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-purple-400 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-purple-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-purple-400 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-purple-400 transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-white font-medium mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/search" className="text-sm hover:text-purple-400 transition-colors">Find Musicians</Link>
              </li>
              <li>
                <Link to="/profile" className="text-sm hover:text-purple-400 transition-colors">Profile</Link>
              </li>
              <li>
                <Link to="/messages" className="text-sm hover:text-purple-400 transition-colors">Messages</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="col-span-1">
            <h3 className="text-white font-medium mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-sm hover:text-purple-400 transition-colors">Terms of Service</Link>
              </li>
              {/* <li>
                <Link to="/privacy" className="text-sm hover:text-purple-400 transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/cookies" className="text-sm hover:text-purple-400 transition-colors">Cookie Policy</Link>
              </li>
              <li>
                <Link to="/licensing" className="text-sm hover:text-purple-400 transition-colors">Licensing</Link>
              </li> */}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-xs text-gray-500 mb-4 md:mb-0">
            © {currentYear} JustJam. All rights reserved.
          </p>
          <div className="flex space-x-4">
            {/* <a href="#" className="text-xs text-gray-500 hover:text-purple-400 transition-colors">
              Help Center
            </a>
            <a href="#" className="text-xs text-gray-500 hover:text-purple-400 transition-colors">
              Contact Support
            </a>
            <a href="#" className="text-xs text-gray-500 hover:text-purple-400 transition-colors">
              FAQ
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
